import React from 'react'

import clsx from 'clsx'

import Rating from 'components/Rating'
import Typography from 'components/Typography'
import { REVIEW_FIELDS, LIKELIHOOD_FIELD } from 'helpers/domain'
import { formatRatingAverage } from 'helpers/formatters'

import classes from './RatingCriteria.module.scss'

/** @type {import("./types").default} */
const RatingCriteria = ({ className, fields = {}, averageFormat = false }) => (
  <ul className={clsx('RatingCriteria', classes.root, className)}>
    {REVIEW_FIELDS.map(field => (
      <Rating.CriteriaItem
        className={classes.item}
        component="li"
        label={field.text}
        average={fields[field.slug]}
        key={`rating-criteria-${field.slug}`}
      />
    ))}
    {fields[LIKELIHOOD_FIELD.slug] ? (
      <li
        className={clsx(classes.item, classes.flexible)}
        key="rating-criteria-likelihood"
        data-tesid="rating-criteria-likelihood"
      >
        <Typography variant="tight-xs" component="span">
          {LIKELIHOOD_FIELD.text}
        </Typography>
        <Typography variant="tight-xs" component="span">
          <span className={classes.likelihood}>
            {averageFormat ? formatRatingAverage(fields[LIKELIHOOD_FIELD.slug]) : fields[LIKELIHOOD_FIELD.slug]}
          </span>
          /10
        </Typography>
      </li>
    ) : null}
  </ul>
)

export default RatingCriteria
